import React, { useState } from 'react';

const AuthForm = ({ type, onSubmit, onError, onSwitchMode }) => {
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            if (type === 'signup') {
                if (name.trim() && phone.trim()) {
                    await onSubmit(name.trim(), phone.trim());
                } else {
                    setError('Please fill in all fields');
                }
            } else {
                if (phone.trim()) {
                    await onSubmit(phone.trim());
                } else {
                    setError('Please enter your phone number');
                }
            }
        } catch (err) {
            setError(err.message || 'An error occurred');
            if (onError) onError(err.message || 'An error occurred');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={styles.formWrapper}>
            <form onSubmit={handleSubmit} style={styles.authForm}>
                {error && <div style={styles.errorMessage}>{error}</div>}
                
                {type === 'signup' && (
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Your Full Name"
                        style={styles.input}
                        required
                        disabled={isLoading}
                    />
                )}
                <input
                    type="tel"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="Your 10-digit Phone Number"
                    style={styles.input}
                    pattern="[0-9]{10}"
                    required
                    disabled={isLoading}
                />
                <button type="submit" style={styles.submitButton} disabled={isLoading}>
                    {isLoading ? 'Processing...' : (type === 'signup' ? 'Sign Up' : 'Login')}
                </button>
            </form>
            
            {/* Navigation option to switch between signup and login */}
            <div style={styles.switchContainer}>
                <button
                    type="button"
                    onClick={() => onSwitchMode(type === 'signup' ? 'login' : 'signup')}
                    style={styles.switchButton}
                    disabled={isLoading}
                >
                    {type === 'signup' ? 'Already a member? Login' : 'New member? Sign Up'}
                </button>
            </div>
        </div>
    );
};

// --- Styles ---
const styles = {
    formWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        maxWidth: '300px',
    },
    authForm: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        width: '100%',
        backgroundColor: '#f9f9f9',
        padding: '20px',
        borderRadius: '12px',
        border: '1px solid #ddd',
    },
    input: {
        padding: '12px',
        fontSize: '1rem',
        borderRadius: '8px',
        border: '1px solid #ccc',
    },
    submitButton: {
        backgroundColor: '#007aff',
        color: 'white',
        padding: '12px',
        fontSize: '1rem',
        borderRadius: '8px',
        border: 'none',
        cursor: 'pointer',
        fontWeight: 'bold',
        transition: 'opacity 0.2s ease',
    },
    switchContainer: {
        marginTop: '15px',
        textAlign: 'center',
    },
    switchButton: {
        backgroundColor: 'transparent',
        color: '#007aff',
        border: 'none',
        fontSize: '0.9rem',
        cursor: 'pointer',
        textDecoration: 'underline',
        padding: '5px',
        fontWeight: '500',
        transition: 'color 0.2s ease',
    },
    errorMessage: {
        backgroundColor: '#ffebee',
        color: '#c62828',
        padding: '10px',
        borderRadius: '6px',
        fontSize: '0.9rem',
        border: '1px solid #ffcdd2',
    },
};

export default AuthForm;